import { DEFAULT_LOCALE } from '../../../modules/i18n/locales';
import { getPageLocale } from '../../../src/web/store/modules/pageBuilder';

const getLocale = (state) => {
  const inBuilder = window.location.pathname.startsWith('/admin/page/edit');

  return inBuilder ? getPageLocale(state) : DEFAULT_LOCALE;
};

export default getLocale;
